import { LayoutInlineForm } from '../../types/types';

// Skips items the user has no input for (statically hidden by the definition).
export const isValidatableLayoutItem = (
  item: LayoutInlineForm['items'][number]
): boolean =>
  !!item.name && item.visible !== false && item.allowVisible !== false;
